var jQuery = $;
import marquee from "../../node_modules/jquery.marquee/jquery.marquee.min.js";
import swiper from "../../node_modules/swiper/swiper-bundle.js";
import fancy from "../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js";
import axios from 'axios';

var vacancies = [];
var activeFilters = { branches: [], educations: [], locations: [], hours: [], searchKey: '', hasDefaultSearch: false, searchKeyType: false, postalCode: '', radius: 20 };

const app = {
    /** Initialize */
    init() {
        this.yyVacatuciesFilters();

        // Init marquees
        this.initMarquees();

        // Init swiper
        this.initSwiperSliders();

        // Fade sections in on scroll
        // this.fadeInOnScroll();

        // Toggle filters for mobile
        this.toggleFilters();

        // this.toggleFiltersDesktop();

        // Toggle FAQ accordion
        this.toggleFaqItems();

        this.negativeTopAndLast();

        // Add border to checkbox when checked
        this.toggleBorderAroundCheckbox();

        this.readMore();

        // Smooth anchor
        this.smoothAnchor();

        // Set extra class on second section if needed
        this.setSecondSectionClass();

        this.scrolltoTopFilter();

        this.initPopups();

        this.initDatalayers();

        // this.initVacancyOverviewHelpers();

        // this.removeAndShowNavigationOnScroll();

        $(window).on("scroll", $.proxy(this.windowScrollHandler, this));
        $(".hamburger").on("click", $.proxy(this.toggleHamburgerMenu, this));
        // $('.contact-button, .close-contact-popup').on('click', $.proxy(this.toggleContactoptions, this));
        $(".filter-button, .filter-item-desktop, .button.results-button").on(
            "click",
            $.proxy(this.toggleFiltersmenu, this)
        );
        $(".filter-item-desktop").on(
            "click",
            $.proxy(this.scrolltoTopFilter, this)
        );
        $(".close-filter").on("click", $.proxy(this.toggleFiltersmenu, this));
        $(".close-filter-desktop").on(
            "click",
            $.proxy(this.hideFilterMenuDesktop, this)
        );
    },

    initDatalayers() {
        this.faqDatalayers();
        this.filtersDatalayers();
        this.applyButtonDatalayers();
    },

    applyButtonDatalayers() {
        if (!$('.trackable-button').length) {
            return;
        }

        $('.trackable-button').on('click', function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'cta_direct_solliciteren',
            });
        });
    },

    filtersDatalayers() {
        $('.filter-options .filter-item').on('change', function () {
            const dlKey = $(this).hasClass('branches') ? 'vakgebied' :
                $(this).hasClass('locations') ? 'locatie' :
                    $(this).hasClass('educations') ? 'opleidingsniveau' : 'hours';

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'filter',
                'details': [
                    {
                        [dlKey]: $(this).parent().find('label').text()
                    }
                ]
            });
        })
    },

    faqDatalayers() {
        if (!$('.accordion.two-cols').length) {
            return;
        }

        $('.accordion.two-cols .accordion-item .accordion-heading').on('click', function () {
            if ($(this).parent().find('.accordion-content').hasClass('hidden')) {
                return;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'faq',
                'question': $(this).find('h3').text().trim(),
            });
        });
    },

    async yyVacatuciesFilters() {
        if (!$('.section.vacancies-overview').length) {
            return;
        }

        vacancies = this.updateVacancyContent($('.section.vacancies-overview .vacancy.not-related'));

        this.getVacancyQueryParameters();
        this.setDefaultOverviewFilters();

        this.setVacancyCount(vacancies.length);

        const [branches, locations, educations, workHours] = this.getVacancyOverviewFilters(vacancies);

        this.popuplateBrancheFilters(branches);
        this.popuplateEducationFilters(educations);
        this.popuplateLocationFilters(locations);
        this.popuplateWorkHoursFilters(workHours);

        this.initOverviewSearchbarListeners();
        this.initDropdownFiltersListeners();
        this.updateVacancyContent();
    },

    async setDefaultOverviewFilters() {
        const vacanciesWrapper = $('.section.vacancies-overview .vacancies-wrapper');
        var branche = ($(vacanciesWrapper).attr('data-filter-branche') !== 'none') ? $(vacanciesWrapper).attr('data-filter-branche') : null;
        var education = ($(vacanciesWrapper).attr('data-filter-education') !== 'none') ? $(vacanciesWrapper).attr('data-filter-education') : null;
        var location = ($(vacanciesWrapper).attr('data-filter-location') !== 'none') ? $(vacanciesWrapper).attr('data-filter-location') : null;
        var weekHours = ($(vacanciesWrapper).attr('data-filter-weekhours') !== 'none') ? $(vacanciesWrapper).attr('data-filter-weekhours') : null;
        var searchTerm = ($(vacanciesWrapper).attr('data-filter-searchterm') !== 'none') ? $(vacanciesWrapper).attr('data-filter-searchterm') : null;
        var searchTermType = ($(vacanciesWrapper).attr('data-filter-type') !== 'none') ? $(vacanciesWrapper).attr('data-filter-type') : null;

        this.updateFilters('branches', true, branche);
        this.updateFilters('educations', true, education);
        this.updateFilters('locations', true, location);
        this.updateFilters('hours', true, weekHours);

        if (searchTerm && searchTerm != 'none') {
            activeFilters.searchKey = searchTerm;
            activeFilters.hasDefaultSearch = true;
            $('#custom-search-form-function').val(searchTerm);
        }

        if (searchTermType && (searchTermType == 'EN' || searchTermType == 'OF')) {
            activeFilters.searchKeyType = searchTermType;
        }

        this.setActiveFilters(activeFilters);
        const filteredVacancies = await this.filterAndSearchVacancies(vacancies, activeFilters);
        this.updateVacancyResults(filteredVacancies);
    },

    updateVacancyContent(vacancies) {
        $(vacancies).each(function () {
            $(this).find('.vacancy-content p').each(function () {
                if ($(this).html() == '&nbsp;') {
                    $(this).remove();
                } else {
                    $(this).append(' ');
                }
            })
        });

        return $(vacancies);
    },

    async getVacancyQueryParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get('search');
        const postalCode = urlParams.get('zipcode');
        const radius = urlParams.get('radius') ?? 10000;

        if (!searchQuery && !postalCode) {
            return;
        }

        this.seachComponentDatalayers(searchQuery, postalCode, radius);

        if (radius && (radius != 10000 || radius != '')) {
            $('#custom-search-form-radius').val(radius);
            activeFilters.radius = radius;
        }

        if (searchQuery) {
            $('#custom-search-form-function').val(searchQuery);
            activeFilters.searchKey = searchQuery;
        }

        if (postalCode) {
            $('#custom-search-form-postalcode').val(postalCode);
            activeFilters.postalCode = postalCode;
        }

        const filteredVacancies = await this.filterAndSearchVacancies(vacancies, activeFilters);
        this.updateVacancyResults(filteredVacancies);
    },

    seachComponentDatalayers(searchQuery, postalCode, radius) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'zoekfunctie',
            'details': {
                'zoekterm': searchQuery,
                'zipcode': postalCode,
                'radius': radius
            }
        });
    },

    initOverviewSearchbarListeners() {
        const self = this;

        $('#vacancies-overview-searchbar').on('click', async function (e) {
            e.preventDefault();
            activeFilters.hasDefaultSearch = false;
            activeFilters.searchKey = $('#custom-search-form-function').val();
            activeFilters.postalCode = $('#custom-search-form-postalcode').val();
            activeFilters.radius = $('#custom-search-form-radius').val();

            const filteredVacancies = await self.filterAndSearchVacancies(vacancies, activeFilters);
            self.updateVacancyResults(filteredVacancies);
        });
    },

    initDropdownFiltersListeners() {
        const self = this;

        $('#overview-filter-branche .filter-item, #overview-filter-education .filter-item, #overview-filter-workweek .filter-item, #overview-filter-location .filter-item').on('change', function () {
            const category = $(this).hasClass('branches') ? 'branches' : $(this).hasClass('educations') ? 'educations' : $(this).hasClass('locations') ? 'locations' : 'hours';
            self.updateFilters(category, $(this).is(':checked'), $(this).parent().find('label[for="' + $(this).attr('id') + '"]').text());
        });

        $('.filter-checkboxes .results-button, .button.results-button').on('click', async function () {
            const filteredVacancies = await self.filterAndSearchVacancies(vacancies, activeFilters);

            self.updateVacancyResults(filteredVacancies);
        })


        $('.section.vacancies-overview .vacancies-active-filters').on('click', '#active-filter-remove', async function () {
            const $this = $(this).parent().find('.active-filter');
            const category = $this.hasClass('branches') ? 'branches' : $this.hasClass('educations') ? 'educations' : $this.hasClass('locations') ? 'locations' : 'hours';

            self.updateFilters(category, false, $this.text());
            self.setActiveFilters(activeFilters);

            const filteredVacancies = await self.filterAndSearchVacancies(vacancies, activeFilters);
            self.updateVacancyResults(filteredVacancies);
        })

        $('.section.vacancies-overview .vacancies-active-filters .remove-filters, .filters-overview .results-button-reset .reset').on('click', async function () {
            activeFilters = { branches: [], educations: [], locations: [], hours: [], searchKey: '', postalCode: '', radius: 20 };
            self.clearActiveFilter();
            self.setActiveFilters(activeFilters)

            const filteredVacancies = await self.filterAndSearchVacancies(vacancies, activeFilters);
            self.updateVacancyResults(filteredVacancies);
        });
    },

    updateVacancyResults(unFilteredVacancies) {
        let updatedVacancies = this.updateVacancyContent(unFilteredVacancies);
        let hasResults = true;

        updatedVacancies = updatedVacancies.sort(function (a, b) {
            var aVal = $(a).find('#highlighted').text();
            var bVal = $(b).find('#highlighted').text();

            return (bVal == 'Ja') - (aVal == 'Ja');
        }).each(function () {
            var aVal = $(this).find('#highlighted').text();
            if (aVal.trim() !== '') {
                $(this).addClass('highlighted');
            }
        });

        const vacanciesWrapper = $('.section.vacancies-overview .vacancies-wrapper .yy_job_list');
        this.setVacancyCount(updatedVacancies.length);
        this.setActiveFilters(activeFilters);

        if (!updatedVacancies || updatedVacancies.length == 0) {
            const noResultsHTML = `
            <div class="no-results">
                <h3>Helaas hebben we geen vacatures gevonden die overeenkomen met je zoekcriteria.</h3>
                <p>Overweeg het volgende om je zoekresultaten te verbeteren:</p>
                <ul>
                    <li>Verwijder één of meer filters om je zoekopdracht te verbreden.</li>
                    <li>Controleer de functietitel op spelfouten en probeer alternatieve benamingen.</li>
                    <li>Overweeg meerdere vakgebieden aan te vinken voor een ruimere selectie.</li>
                    <li>Als je een postcode hebt gebruikt, zorg dan dat deze volledig is, bijvoorbeeld 1234 AA.</li>
                </ul>
                <h3 class="other-vacancies">Of bekijk onderstaande vacatures</h3>
            </div>`;
        
            $(vacanciesWrapper).empty().html(noResultsHTML);

            hasResults = false;
            updatedVacancies = vacancies;
        }

        if (!hasResults)
        updatedVacancies = updatedVacancies.sort(function (a, b) {
            var aVal = $(a).find('#highlighted').text();
            var bVal = $(b).find('#highlighted').text();

            return (bVal == 'Ja') - (aVal == 'Ja');
        }).each(function () {
            var aVal = $(this).find('#highlighted').text();
            if (aVal.trim() !== '') {
                $(this).addClass('highlighted');
            }
        });

        const chunkedVacancies = [];
        for (let i = 0; i < updatedVacancies.length; i += 15) {
            chunkedVacancies.push(updatedVacancies.slice(i, i + 15));
        }

        if (hasResults) {
            $(vacanciesWrapper).empty()
        }

        $(vacanciesWrapper).append(chunkedVacancies.shift());

        this.initReadMoreVacancies(vacanciesWrapper, chunkedVacancies);

        $('body .vacancies-overview .vacancies-wrapper').on('click', '.show-more-results', function () {
            $(this).remove();
            $(vacanciesWrapper).append(chunkedVacancies.shift());

            if (chunkedVacancies.length <= 0) {
                return;
            }

            $(vacanciesWrapper).append(this);
        });
    },

    initReadMoreVacancies(parentWrapper, vacancies) {
        if (vacancies.length <= 0) {
            return;
        }

        const showMoreButton = document.createElement('button');
        showMoreButton.classList = 'show-more-results button btn alt';

        const text = document.createElement('p');
        text.innerHTML = 'Laad meer vacatures';

        showMoreButton.append(text);

        $(parentWrapper).append(showMoreButton);
    },

    hasFilters(filters) {
        for (const key in filters) {
            if (filters[key].length > 0) {
                return true; // At least one array has items
            }
        }
        return false; // No arrays have items
    },

    setActiveFilters({ branches, educations, locations, hours }) {
        const filtersGrouped = { branches, educations, hours, locations }

        const activeFiltersElement = $('.section.vacancies-overview .vacancies-active-filters .filters');
        $(activeFiltersElement).empty();

        if (this.hasFilters(filtersGrouped)) {
            $('.section.vacancies-overview .vacancies-active-filters .remove-filters').show();
        } else {
            $('.section.vacancies-overview .vacancies-active-filters .remove-filters').hide();
        }

        for (const group in filtersGrouped) {
            if (filtersGrouped.hasOwnProperty(group)) {
                const valuesArray = filtersGrouped[group].sort((a, b) => a.localeCompare(b));

                for (const filter of valuesArray) {
                    const filterName = this.sanitizeString(filter);

                    $(activeFiltersElement).append(`
                    <div class="filter">
                        <div class="inner">
                            <div id="active-filter-remove" class="cross">
                                <i class="fa-solid fa-times"></i>
                            </div>
                            <span class="active-filter ${group}" id="${filterName}">${filter}</span>
                        </div>
                    </div>
                `)
                }
            }
        }
    },

    clearActiveFilter(item) {
        var filter = $('#overview-filter-branche .filter-item, #overview-filter-education .filter-item, #overview-filter-workweek .filter-item');
        if (item) {
            filter = $(`#overview-filter-branche .filter-item#${item}, #overview-filter-education .filter-item#${item}, #overview-filter-workweek .filter-item#${item}`);
        }

        filter.prop('checked', false);
        filter.parent().removeClass('checked');
    },

    updateFilters(category, add, title) {
        if (!title || !category) {
            return;
        }

        const globalFilters = activeFilters;
        // Check if the provided category exists in the filters
        if (category in globalFilters) {
            const categoryArray = globalFilters[category];

            if (add) {
                // Add the title to the category array if not already present
                if (!categoryArray.includes(title)) {
                    categoryArray.push(title);
                }
            } else if (!add) {
                // Remove the title from the category array if present
                const indexToRemove = categoryArray.indexOf(title);
                if (indexToRemove !== -1) {
                    categoryArray.splice(indexToRemove, 1);
                    this.clearActiveFilter(this.sanitizeString(title));
                }
            }
        }

        activeFilters = globalFilters;
    },

    setVacancyCount(count) {
        const resultCount = $('.section.vacancies-overview #vacancy-result-count');
        const filters = [
            {
                toggle: $('#overview-filter-branche-toggle'),
                toggleDesktop: $('#filter-desktop-branche-toggle'),
                activeFilters: activeFilters.branches,
            },
            {
                toggle: $('#overview-filter-education-toggle'),
                toggleDesktop: $('#filter-desktop-education-toggle'),
                activeFilters: activeFilters.educations,
            },
            {
                toggle: $('#overview-filter-location-toggle'),
                toggleDesktop: $('#filter-desktop-location-toggle'),
                activeFilters: activeFilters.locations,
            },
            {
                toggle: $('#overview-filter-workweek-toggle'),
                toggleDesktop: $('#filter-desktop-hours-toggle'),
                activeFilters: activeFilters.hours,
            },
        ];

        resultCount.text(count);

        for (const filter of filters) {
            const { toggle, toggleDesktop, activeFilters } = filter;
            const $counter = toggle.find('.counter');
            const $counterDesktop = toggleDesktop.find('.counter');

            if (activeFilters.length > 0) {
                $counter.text(activeFilters.length);
                $counterDesktop.text(activeFilters.length);
                $counter.css({ opacity: '1' });
                $counterDesktop.css({ opacity: '1' });
            } else {
                $counter.css({ opacity: '0' });
                $counterDesktop.css({ opacity: '0' });
            }
        }
    },

    matchDefaultSearchKeys(searchKeysString, searchKeyType, vacancyTitle) {
        const searchKeys = searchKeysString.split(',');

        if (searchKeyType == 'EN') {
            return searchKeys.every(searchKey => vacancyTitle.text().toLocaleLowerCase().includes(searchKey.toLowerCase().trim()));
        } else if (searchKeyType == 'OF') {
            return searchKeys.some(searchKey => vacancyTitle.text().toLocaleLowerCase().includes(searchKey.toLowerCase().trim()));
        }

        return false;
    },

    async filterAndSearchVacancies(vacancies, { searchKey, hasDefaultSearch, searchKeyType, postalCode, radius, locations, branches, educations, hours }) {
        const searchCoords = postalCode ? await this.fetchPostalCodeCoords(postalCode) : null;
        const filteredVacancies = [];

        for (const vacancy of vacancies) {
            const titleElement = $(vacancy).find('.title-data h3');
            const vacancyPostalCodeElement = $(vacancy).find('#postalcode');
            const vacancyBrancheElement = $(vacancy).find('#branche');
            const vacancyEducationElement = $(vacancy).find('#education');
            const vacancyHoursRangeElement = $(vacancy).find('#hoursRange');
            const vacancyLocationElement = $(vacancy).find('#location');

            const vacancyPostalCode = vacancyPostalCodeElement.length
                ? vacancyPostalCodeElement.text().trim().replaceAll(' ', '')
                : '';

            const vacancyCoords = vacancyPostalCode
                ? await this.fetchPostalCodeCoords(vacancyPostalCode)
                : { lat: 0, long: 0 };

            const titleMatches = hasDefaultSearch ? this.matchDefaultSearchKeys(searchKey, searchKeyType, titleElement) : searchKey ? titleElement.text().toLowerCase().includes(searchKey.toLowerCase()) : true;

            const coordsMatches = postalCode
                ? vacancyCoords.lat !== 0 && vacancyCoords.long !== 0 && await this.isInPostalCodeRange(searchCoords, vacancyCoords, radius)
                : true;

            const brancheText = vacancyBrancheElement.text();
            const educationText = vacancyEducationElement.text();
            const hoursRangeText = vacancyHoursRangeElement.text();
            const locationText = vacancyLocationElement.text();
            const brancheMatch = branches.length === 0 || branches.includes(brancheText);
            const educationMatch = educations.length === 0 || educations.includes(educationText);
            const hoursRangeMatch = hours.length === 0 || hours.includes(hoursRangeText);
            const locationMatch = locations.length === 0 || locations.includes(locationText);

            if (titleMatches && coordsMatches && brancheMatch && educationMatch && hoursRangeMatch && locationMatch) {
                filteredVacancies.push(vacancy);
            }
        }

        return filteredVacancies;
    },

    popuplateBrancheFilters(branches) {
        const branchDropdown = $('#overview-filter-branche');
        const branchDropdownToggle = $('#overview-filter-branche-toggle');
        const branchDropdownToggleDesktop = $('#filter-desktop-branche-toggle');
        const checkBoxes = $(branchDropdown).find('.checkboxes');

        if (branches.length == 0) {
            $(branchDropdownToggle).hide();
            $(branchDropdownToggleDesktop).hide();

            return;
        }


        $(branchDropdownToggle).find('.counter').css({ opacity: '0' });
        $(branchDropdownToggleDesktop).find('.counter').css({ opacity: '0' });

        $(checkBoxes).empty();

        branches.forEach((branche) => {
            const branchName = this.sanitizeString(branche);

            $(checkBoxes).append(`
            <div class="field">
                <input class="filter-item branches" type="checkbox" id="${branchName}" name="${branchName}" value="${branchName}">
                <label for="${branchName}">${branche}</label>
            </div>
            `)
        })
    },

    popuplateLocationFilters(locations) {
        const locationDropdown = $('#overview-filter-location');
        const locationDropdownToggle = $('#overview-filter-location-toggle');
        const locationDropdownToggleDesktop = $('#filter-desktop-location-toggle');
        const checkBoxes = $(locationDropdown).find('.checkboxes');

        if (locations.length == 0) {
            $(locationDropdownToggle).hide();
            $(locationDropdownToggleDesktop).hide();

            return;
        }

        $(locationDropdownToggle).find('.counter').css({ opacity: '0' });
        $(locationDropdownToggleDesktop).find('.counter').css({ opacity: '0' });

        $(checkBoxes).empty();

        locations.forEach((location) => {
            const locationName = this.sanitizeString(location);

            $(checkBoxes).append(`
            <div class="field">
                <input class="filter-item locations" type="checkbox" id="${locationName}" name="${locationName}" value="${locationName}">
                <label for="${locationName}">${location}</label>
            </div>
            `)
        })
    },

    popuplateEducationFilters(educations) {
        const educationDropdown = $('#overview-filter-education');
        const educationDropdownToggle = $('#overview-filter-education-toggle');
        const educationDropdownToggleDesktop = $('#filter-desktop-education-toggle');
        const checkBoxes = $(educationDropdown).find('.checkboxes');

        if (educations.length == 0) {
            $(educationDropdownToggle).hide();
            $(educationDropdownToggleDesktop).hide();

            return;
        }

        $(educationDropdownToggle).find('.counter').css({ opacity: '0' });
        $(educationDropdownToggleDesktop).find('.counter').css({ opacity: '0' });

        $(checkBoxes).empty();

        educations.forEach((education) => {
            const educationName = this.sanitizeString(education);

            $(checkBoxes).append(`
            <div class="field">
                <input class="filter-item educations" type="checkbox" id="${educationName}" name="${educationName}" value="${educationName}">
                <label for="${educationName}">${education}</label>
            </div>
            `)
        })
    },

    popuplateWorkHoursFilters(workHours) {
        const workHoursDropdown = $('#overview-filter-workweek');
        const workHoursDropdownToggle = $('#overview-filter-workweek-toggle');
        const workHoursDropdownToggleDesktop = $('#filter-desktop-hours-toggle');
        const checkBoxes = $(workHoursDropdown).find('.checkboxes');

        if (workHours.length == 0) {
            $(workHoursDropdownToggle).find('.counter').css({ opacity: '0' });
            $(workHoursDropdownToggleDesktop).find('.counter').css({ opacity: '0' });

            return;
        }

        $(workHoursDropdownToggle).find('.counter').text(workHours.length);
        $(workHoursDropdownToggleDesktop).find('.counter').text(workHours.length);

        $(checkBoxes).empty();

        workHours.forEach((workHour) => {
            const workHourName = this.sanitizeString(workHour);

            $(checkBoxes).append(`
            <div class="field">
                <input class="filter-item hours" type="checkbox" id="${workHourName}" name="${workHourName}" value="${workHourName}">
                <label for="${workHourName}">${workHour}</label>
            </div>
            `)
        })
    },

    getVacancyOverviewFilters(vacancies) {
        let branches = [];
        let educations = [];
        let workHours = [];
        let locations = [];

        $(vacancies).each(function () {
            const branche = $(this).find('#branche').text();
            const education = $(this).find('#education').text();
            const hours = $(this).find('#hoursRange').text();
            const location = $(this).find('#location').text();

            if (!locations.includes(location) && location.replaceAll(' ', '') !== '') {
                locations.push(location);
            }

            if (!branches.includes(branche) && branche.replaceAll(' ', '') !== '') {
                branches.push(branche);
            }

            if (!educations.includes(education) && education.replaceAll(' ', '') !== '') {
                educations.push(education);
            }

            if (!workHours.includes(hours) && hours.replaceAll(' ', '') !== '') {
                workHours.push(hours);
            }
        });

        return [
            branches,
            locations,
            educations,
            workHours
        ]
    },

    async fetchPostalCodeCoords(postalCode) {
        return await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${postalCode}.json?proximity=ip&access_token=pk.eyJ1IjoiaGVucmlrNTYxIiwiYSI6ImNsbTR4eHAyODRocGgzY3B2NjB3MmNkY3UifQ.11MmPIvgot7hntqtzjhVjQ`)
            .then((response) => {
                return { long: response.data.features[0]['geometry']['coordinates'][0], lat: response.data.features[0]['geometry']['coordinates'][1] }
            })
            .catch((error) => {
                return { long: 0, lat: 0 }
            })
    },

    async isInPostalCodeRange(coordsOne, coordsTwo, maxDistance) {
        const R = 6371; // Radius of the Earth in km
        const dLat = (coordsTwo.lat - coordsOne.lat) * (Math.PI / 180);
        const dLon = (coordsTwo.long - coordsOne.long) * (Math.PI / 180);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(coordsOne.lat * (Math.PI / 180)) * Math.cos(coordsTwo.lat * (Math.PI / 180)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c; // Distance in km

        return distance <= maxDistance;
    },

    sanitizeString(inputString) {
        // Remove HTML characters using a regular expression
        const sanitizedString = inputString.replace(/<\/?[^>]+(>|$)/g, '').replace(',', '').replace('&', '');

        // Remove spaces using the split and join method
        const stringWithoutSpaces = sanitizedString.split(' ').join('');

        return stringWithoutSpaces;
    },

    readMore() {
        $('#read-more-button').click(function () {
            const textContainer = $('#text-container');
            const buttonText = $(this).find('.button-text');

            if (textContainer.hasClass('expanded')) {
                textContainer.removeClass('expanded');
                $(this).removeClass('open');
                buttonText.text('Lees meer');
            } else {
                textContainer.addClass('expanded');
                $(this).addClass('open');
                buttonText.text('Lees minder');
            }
        });
    },

    negativeTopAndLast() {
        $('.images-text').each(function () {
            if ($(this).prev().hasClass('recent-blogs')) {
                $(this).addClass('negative-top');
            }
        });

        var lastSection = $('.section:last');
        if (lastSection.hasClass('images-text')) {
            lastSection.addClass('last-section');
        }
    },

    /** Handles the scroll event */
    windowScrollHandler() {
        $("header").toggleClass("scrolled", $(window).scrollTop() > 0);
    },

    /** Open hamburger menu */
    toggleHamburgerMenu() {
        $("header").toggleClass("open");
        $(".hamburger").toggleClass("active");
        $("nav.navigation").toggleClass("visible");
        // $(".navigation-bg").toggleClass('active');
        $("body").toggleClass("is-locked");
    },

    // toggleFilters() {
    //     $(".toggle-title").on("click", function () {
    //         $('.filter-item').addClass('hidden'); // Eerst voegen we de class 'hidden' toe aan alle .filter-item elementen
    //         $(this).parent().removeClass("hidden"); // Vervolgens verwijderen we de class 'hidden' van het huidige .filter-item
    //     });
    // },

    scrolltoTopFilter() {
        if ($(window).width() >= 1024) {
            $(".filter-item-desktop").on("click", function () {
                var filtersDesktopOffsetTop = $(
                    ".filters-desktop .filter-tabs"
                ).offset().top;

                $("html, body").animate(
                    {
                        scrollTop: filtersDesktopOffsetTop,
                    },
                    500
                ); // De duur van de animatie is 500 milliseconden. Verander dit getal om de snelheid van de animatie aan te passen.
            });
        }
    },

    toggleBorderAroundCheckbox() {
        $(".field input").on("change", function () {
            if ($(this).is(":checked")) {
                $(this).parent(".field").addClass("checked");
            } else {
                $(this).parent(".field").removeClass("checked");
            }
        });
    },

    toggleFilters() {
        if ($(window).width() < 1024) {
            $(".toggle-title").on("click", function () {
                // Voeg eerst de class 'hidden' toe aan alle .filter-item elementen
                $(".filter-item").addClass("hidden");
                // Verwijder vervolgens de class 'hidden' van het huidige .filter-item
                $(this).parent().removeClass("hidden");

                // Krijg de classes van het huidige filter-item, split ze en vind de tweede class
                const secondClass = $(this)
                    .parent()
                    .attr("class")
                    .split(" ")[1];

                // Verwijder eerst de class 'active' van alle .filter-checkboxes elementen
                $(".filter-checkboxes").removeClass("active");
                // Voeg vervolgens de class 'active' toe aan het .filter-checkboxes element met dezelfde tweede class
                $(`.filter-checkboxes.${secondClass}`).addClass("active");
            });
        }

        $(".toggle-title").on("click", function () {
            // Voeg eerst de class 'hidden' toe aan alle .filter-item elementen
            $(".filter-item-desktop").addClass("hidden");
            // Verwijder vervolgens de class 'hidden' van het huidige .filter-item
            $(this).parent().removeClass("hidden");
        });

        if ($(window).width() >= 1024) {
            // Definieer een functie die de `active` class verwijdert als de breedte >= 1024px
            function checkWindowWidth() {
                $(".filter-checkboxes").removeClass("active");
            }

            // Roep de functie aan bij het laden van de pagina
            checkWindowWidth();

            // Voeg een event listener toe voor het resize event
            $(window).resize(function () {
                checkWindowWidth();
            });

            $(".toggle-title").on("click", function () {
                const secondClass = $(this)
                    .parent()
                    .attr("class")
                    .split(" ")[1];
                $(".filter-item, .filter-checkboxes").removeClass("active");
                $(
                    `.filter-item.${secondClass}, .filter-checkboxes.${secondClass}`
                ).addClass("active");
            });

            // $("body").toggleClass('is-locked');
        }
    },

    // toggleFiltersDesktop() {
    //     if ($(window).width() >= 1024) {

    //     }
    // },

    toggleFiltersmenu() {
        if ($(window).width() < 1024) {
            $(".filters-overview").toggleClass("active");
            $("body").toggleClass("is-locked");
        }

        if ($(window).width() >= 1024) {
            $("body").addClass("is-locked");
            $(".filters-overlay").addClass("active");
        }
    },

    hideFilterMenuDesktop() {
        if ($(window).width() >= 1024) {
            $(".filter-checkboxes").removeClass("active");
            $("body").removeClass("is-locked");

            $(".filter-item-desktop").addClass("hidden");
            $(".filters-overlay").removeClass("active");
        }
    },

    /** Open FAQ accordion */
    toggleFaqItems() {
        $(".toggle-heading").on("click", function () {
            if ($(this).parent().find(".toggle-content").hasClass("hidden")) {
                $(this).parent().find(".toggle-content.hidden").slideDown(500);
                $(this)
                    .parent()
                    .find(".toggle-content.hidden")
                    .removeClass("hidden");
                $(this)
                    .find(".arrow-wrapper")
                    .removeClass("down")
                    .addClass("up");
            } else {
                $(this).parent().find(".toggle-content").slideUp(500);
                $(this).parent().find(".toggle-content").addClass("hidden");
                $(this)
                    .find(".arrow-wrapper")
                    .removeClass("up")
                    .addClass("down");
            }
        });
    },

    initMarquees() {
        if ($(window).width() <= 428) {
            $(".pageheader-marquee").marquee({
                duplicated: true,
                gap: 30,
                startVisible: true,
                duration: 20000,
            });
        }

        if ($(window).width() <= 768) {
            $(".usp-bar .inner").marquee({
                duplicated: true,
                gap: 30,
                startVisible: true,
                duration: 20000,
            });
        }

        if ($(window).width() <= 768) {
            $(".footer-bottom .usps").marquee({
                duplicated: true,
                gap: 30,
                startVisible: true,
                duration: 20000,
            });
        }
    },

    initSwiperSliders() {
        const swiperOneReviewslider = new Swiper(".reviews .reviews-wrapper", {
            slidesPerView: 1,
            loop: true,
            grabCursor: true,
            effect: "fade",
            autoplay: {
                delay: 10000,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        const swiperThreeSlides = new Swiper(".images-slider-wrapper", {
            slidesPerView: 1.6,
            loop: true,
            spaceBetween: 25,
            grabCursor: true,
            breakpoints: {
                768: {
                    slidesPerView: 3.2,
                },
                1024: {
                    slidesPerView: 3.4,
                    spaceBetween: 40,
                },
                1280: {
                    slidesPerView: 3.6,
                    spaceBetween: 80,
                },
            },
        });

        // const swiperTwoReviewsslider = new Swiper('.two-reviews .reviews-wrapper', {
        //     slidesPerView: 1.3,
        //     loop: true,
        //     spaceBetween: 25,
        //     grabCursor: true,
        //     breakpoints: {
        //         480: {
        //             slidesPerView: 1.1,
        //         },
        //         768: {
        //             slidesPerView: 1.4,
        //         },
        //         1024: {
        //             slidesPerView: 1.7,
        //             spaceBetween: 30,
        //         },
        //         1280: {
        //             slidesPerView: 1.7,
        //             spaceBetween: 30,
        //         }
        //     },
        // });

        // const swiperThreeReviewsslider = new Swiper('.three-reviews .reviews-wrapper', {
        //     slidesPerView: 1.3,
        //     loop: true,
        //     spaceBetween: 25,
        //     grabCursor: true,
        //     breakpoints: {
        //         480: {
        //             slidesPerView: 1.1,
        //         },
        //         768: {
        //             slidesPerView: 1.4,
        //         },
        //         1024: {
        //             slidesPerView: 2.5,
        //             spaceBetween: 30,
        //         },
        //         1280: {
        //             slidesPerView: 2.4,
        //             spaceBetween: 30,
        //         }
        //     },
        // });
    },

    // Smooth anchor
    smoothAnchor() {
        var $root = $("html, body");

        $('a[href^="#"]:not(.open-popup)').click(function (e) {
            if (
                $(this).attr("href") !== "#reservation" &&
                $(this).attr("href") !== "#" &&
                $(this).attr("href") !== "#popup"
            ) {
                e.preventDefault();

                $root.animate(
                    {
                        scrollTop: $($.attr(this, "href")).offset().top - 60,
                    },
                    500
                );

                return false;
            } else {
                e.preventDefault();
            }
        });
    },

    /** Fade sections in on scroll */
    // fadeInOnScroll() {
    //     $.fn.initFadeIn = function () {
    //         $('.section').each(function () {
    //             let top_of_element = $(this).offset().top + 150;
    //             let bottom_of_element = $(this).offset().top + $(this).outerHeight();
    //             let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    //             let top_of_screen = $(window).scrollTop();
    //             if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
    //                 $(this).addClass('is-visible');
    //             }
    //         });
    //     };
    //     $.fn.initFadeIn();
    //     $(window).scroll(function () {
    //         $.fn.initFadeIn();
    //     });
    // },

    // removeAndShowNavigationOnScroll() {

    //     var lastScrollTopPosition;

    //     let header = document.getElementById('header');

    //     window.addEventListener('scroll', function () {
    //         let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    //         if (scrollTop > lastScrollTopPosition) {
    //             if (window.innerWidth > 1024) {
    //                 header.style.top = '-80px';
    //             } else {
    //                 header.style.top = '-70px';
    //             }
    //         } else {
    //             header.style.top = '0';
    //         }

    //         lastScrollTopPosition = scrollTop;
    //     });
    // },

    setSecondSectionClass() {
        if ($(".section.pageheader, .section.pageheader-alt").length) {
            $("body")
                .find(".section:nth-child(2)")
                .addClass("has-rounded-corners");
        }
    },

    initPopups() {
        $('a[href="#popup"').on("click", function (e) {
            $('body').addClass('is-locked');

            e.preventDefault();
            $.fancybox.open({
                src: "#jobApplicationPopup",
                type: "inline",
                touch: false,
                smallBtn: true,
                clickSlide: false,
                buttons: [""],
                openEffect: "none",
                closeEffect: "none",
                clickOutside: "close",
                afterClose: function () {
                    $("body").removeClass("is-locked");
                },
            });
        });

        $('.open-package-popup, .close-popup, .popup-bg').on("click", function (e) {
            if ($(e.target).hasClass('popup-bg') && !$('.open-package-popup').hasClass('active')) {
                return;
            }

            $('.package-popup, .popup-bg').toggleClass('active');
            $('body').toggleClass('is-locked');


            if ($(this).hasClass('open-package-popup')) {
                $('.package-popup').find('.title').text($(this).parent().attr('data-package-title'));
                $('.package-popup').find('.description').empty().append($(this).parent().attr('data-package-description'));
            }
        });
    },
};

$(document).ready($.proxy(app.init, app));
